import { Toolbar } from '@mui/x-data-grid-pro';
import { useFetchMyProfileQuery } from '@api/Trinium/Endpoints/myProfile';
import ViewPrintAction from './Actions/ViewPrint';
import ApproveAction from './Actions/Approve';
import DeleteAction from './Actions/Delete';
import EditAction from './Actions/Edit';

import styles from './DataGrid.DocumentControl.module.css';

/**
 * Toolbar that sits on top of the Document Control data grid and displays actions available.
 */
export default function DocumentControlGridToolbar() {
	const { data: userProfile } = useFetchMyProfileQuery(undefined);
	return (
		<Toolbar className={styles.toolbar}>
			<div className={styles['toolbar-buttons']}>
				{userProfile?.canDeleteDocuments && (
					<>
						<EditAction />
						<DeleteAction />
					</>
				)}
				<ApproveAction />
				<ViewPrintAction />
			</div>
		</Toolbar>
	);
}
